<div class="dialog-header">
    <h2 mat-dialog-title>
        {{ 'NAVIGATION.DIALOGS.CHANGE-COMPANY.TITLE' | translate }}
    </h2>
</div>

<div mat-dialog-content>

    <div class="search-container">
        <mat-form-field appearance="outline" class="alim-mat-form-field search-field">
            <mat-label>{{ 'NAVIGATION.DIALOGS.CHANGE-COMPANY.SEARCH_LABEL' | translate }}</mat-label>
            <input matInput [(ngModel)]="searchText" (input)="filterCompanies()" (keydown)="onKeyDown($event)" [placeholder]="'NAVIGATION.DIALOGS.CHANGE-COMPANY.SEARCH_PLACEHOLDER' | translate">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <button mat-icon-button class="add-company-button"
            (click)="openNewCompanyDialog()"
            [matTooltip]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.TITLE' | translate"
            [attr.aria-label]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.TITLE' | translate">
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <div class="company-list-container" (scroll)="onScroll($event)">

        <!-- Loading inicial -->
        <div *ngIf="isLoading && companies.length === 0" class="loading">
            <span>{{ 'NAVIGATION.DIALOGS.CHANGE-COMPANY.LOADING_INITIAL' | translate }}</span>
            <mat-spinner diameter="30"></mat-spinner>
        </div>

        <mat-list *ngIf="!isLoading || companies.length > 0">
            <mat-list-item *ngFor="let company of filteredCompanies; let i = index" (click)="changeCompany(company)" (mouseenter)="onMouseEnter(i)" [class.keyboard-selected]="selectedIndex === i" class="company-item">

                <div>
                    <div class="company-name">
                        {{ company.name || ('NAVIGATION.DIALOGS.CHANGE-COMPANY.FIELDS.NAME_FALLBACK' | translate) }}
                    </div>

                    <div class="company-legal-name">
                        {{ company.legalName || ('NAVIGATION.DIALOGS.CHANGE-COMPANY.FIELDS.LEGAL_NAME_FALLBACK' | translate) }}
                    </div>
                </div>

            </mat-list-item>

            <!-- Spinner para carga adicional -->
            <div *ngIf="isLoading && companies.length > 0" class="loading-more">
                <mat-spinner diameter="20"></mat-spinner>
                <span>{{ 'NAVIGATION.DIALOGS.CHANGE-COMPANY.LOADING_MORE' | translate }}</span>
            </div>
        </mat-list>

        <!-- Sin resultados con búsqueda -->
        <div *ngIf="filteredCompanies.length === 0 && searchText && !isLoading" class="no-results">
            {{ 'NAVIGATION.DIALOGS.CHANGE-COMPANY.NO_RESULTS_SEARCH' | translate:{ searchText: searchText } }}
        </div>

        <!-- Sin empresas disponibles -->
        <div *ngIf="companies.length === 0 && !searchText && !isLoading" class="no-results">
            {{ 'NAVIGATION.DIALOGS.CHANGE-COMPANY.NO_COMPANIES' | translate }}
        </div>

    </div>

</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()">
        {{ 'NAVIGATION.DIALOGS.CHANGE-COMPANY.ACTIONS.CLOSE' | translate }}
    </button>
</div>
